import { render } from "./PronosticoTables.vue?vue&type=template&id=582da85d"
import script from "./PronosticoTables.vue?vue&type=script&lang=js"
export * from "./PronosticoTables.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__